/** Money is integer ngwee (1 ZMW = 100 ngwee). No float arithmetic anywhere. */

export function assertNgwee(value: number, label = 'amount'): void {
  if (typeof value !== 'number' || !Number.isSafeInteger(value)) {
    throw new Error(`${label} must be a safe integer number of ngwee, got ${String(value)}`);
  }
}

export function addNgwee(a: number, b: number): number {
  assertNgwee(a, 'addend');
  assertNgwee(b, 'addend');
  const r = a + b;
  assertNgwee(r, 'sum');
  return r;
}

export function sumNgwee(values: readonly number[]): number {
  let total = 0;
  for (const v of values) total = addNgwee(total, v);
  return total;
}

function group(digits: string): string {
  let out = '';
  for (let i = 0; i < digits.length; i++) {
    if (i > 0 && (digits.length - i) % 3 === 0) out += ',';
    out += digits[i];
  }
  return out;
}

export function formatKwacha(ngwee: number): string {
  assertNgwee(ngwee);
  const neg = ngwee < 0;
  const abs = Math.abs(ngwee);
  const whole = Math.floor(abs / 100);
  const frac = abs % 100;
  const fracStr = frac < 10 ? `0${frac}` : String(frac);
  return `${neg ? '-' : ''}K${group(String(whole))}.${fracStr}`;
}

export function parseKwacha(input: string): number | null {
  if (typeof input !== 'string') return null;
  let s = input.trim();
  if (s.startsWith('K') || s.startsWith('k')) s = s.slice(1).trim();
  if (s === '') return null;
  const m = /^(\d[\d,]*|)(?:\.(\d{1,2}))?$/.exec(s);
  if (!m) return null;
  const wholeRaw = m[1] ?? '';
  const fracRaw = m[2] ?? '';
  if (wholeRaw === '' && fracRaw === '') return null;
  if (wholeRaw.includes(',') && !/^\d{1,3}(,\d{3})+$/.test(wholeRaw)) return null;
  const whole = wholeRaw.replace(/,/g, '') || '0';
  const frac = (fracRaw + '00').slice(0, 2);
  const w = Number(whole);
  if (!Number.isSafeInteger(w)) return null;
  const result = w * 100 + Number(frac);
  return Number.isSafeInteger(result) ? result : null;
}

/**
 * ngwee -> the text a person would type into an amount box: 7550 -> '75.50',
 * 5000 -> '50'. Integer maths only (no floats), and always round-trips through
 * parseKwacha.
 */
export function toInputText(ngwee: number): string {
  assertNgwee(ngwee)
  const negative = ngwee < 0
  const abs = Math.abs(ngwee)
  const whole = Math.trunc(abs / 100)
  const cents = abs % 100
  const text = cents === 0 ? String(whole) : `${whole}.${String(cents).padStart(2, '0')}`
  return negative ? `-${text}` : text
}
